import React from 'react';

import { AIEventsInstrumentationProvider } from '@atlassian/ai-analytics';
import type { AIEventsInstrumentationConfig } from '@atlassian/ai-analytics';

import { Attribution, ErrorBoundary } from '@confluence/error-boundary';
import { fg } from '@confluence/feature-gating';

import { PageCatchupStreamingComponent } from './PageCatchupStreamingComponent';
import { PageCatchupVersionDiffWrapperComponent } from './PageCatchupVersionDiffWrapperComponent';

export type PageCatchupWrapperComponentProps = {
	contentId: string;
	contentType: string;
	spaceKey: string;
	source?: string;
	selectedVersions?: Set<any>;
	isInObjectSidebar?: boolean;
};

export const PageCatchupComponentWithErrorBoundary = (props: PageCatchupWrapperComponentProps) => {
	const aiAnalyticsConfig: AIEventsInstrumentationConfig = {
		product: 'confluence',
		subproduct: 'confluence',
		source: props.source ?? 'confluencePage',
		aiFeatureName: 'pageCatchup',
		proactiveGeneratedAI: 0,
		userGeneratedAI: 1,
	};

	const hasSelectedVersions =
		props.selectedVersions && props.selectedVersions.size > 1 && props.source === 'pageHistory';

	const pageCatchupComponent =
		hasSelectedVersions && fg('confluence_ai_page_catchup_convo_ai_migration') ? (
			<PageCatchupVersionDiffWrapperComponent {...props} />
		) : (
			<PageCatchupStreamingComponent {...props} />
		);

	return (
		<ErrorBoundary attribution={Attribution.SMARTS}>
			<AIEventsInstrumentationProvider config={aiAnalyticsConfig}>
				{pageCatchupComponent}
			</AIEventsInstrumentationProvider>
		</ErrorBoundary>
	);
};
